export enum CarExtraFilter {
  SEVEN_SEATER = 'sevenSeater',
  TOW_HITCH = 'towHitch',
}
